// Suggestions from the document check (noc-strapi utils/documentProofreading): each names the
// path of a text in the document content, the exact text to replace and its replacement.

export const FINDING_KIND_LABELS = Object.freeze({
	spelling: 'Spelling',
	grammar: 'Grammar',
	wording: 'Wording',
	consistency: 'Numbers',
	placeholder: 'Placeholder',
});

export const getAtPath = (root, path = []) =>
	path.reduce((value, key) => (value === null || value === undefined ? undefined : value[key]), root);

/** The finding can still be applied: its text is unchanged in the document. */
export const findingStillApplies = (content, finding) => {
	const text = getAtPath(content, finding?.path);
	return typeof text === 'string' && Boolean(finding?.original) && text.includes(finding.original);
};

/** Replaces the finding's text in place. Returns false when the text has changed since the check. */
export const applyFinding = (content, finding) => {
	if (!finding?.suggestion || !findingStillApplies(content, finding)) return false;
	const parent = getAtPath(content, finding.path.slice(0, -1));
	const key = finding.path[finding.path.length - 1];
	// A function replacement keeps "$" in the suggestion literal.
	parent[key] = parent[key].replace(finding.original, () => finding.suggestion);
	return true;
};

const humanize = (key) => {
	const words = String(key).replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
	return words.charAt(0).toUpperCase() + words.slice(1);
};

// Texts outside a titled section, named as the editor's "On this page" list names them.
const PLACE_LABELS = Object.freeze({
	subtitle: 'Details',
	summaryParagraphs: 'Summary',
	serviceDetails: 'Client and service',
});

// An assignment confirmation keeps its service areas and tasks in one scope section.
const SCOPE_PLACE_LABELS = Object.freeze({
	serviceAreas: 'Service areas',
	regularTasks: 'Regular tasks',
	monthlyTasks: 'Monthly tasks',
	monthlyFootnote: 'Monthly tasks',
});

const ROW_WORDS = Object.freeze({ rows: 'row', phases: 'phase' });

/** Where in the document the finding is, in the editor's words: "Cleaning Schedule · row 4". */
export const describeFindingPlace = (content, path = []) => {
	const [section, second] = path;
	const sectionValue = content?.[section];
	let place = PLACE_LABELS[section] || humanize(section);
	if (section === 'scope' && SCOPE_PLACE_LABELS[second]) {
		place = SCOPE_PLACE_LABELS[second];
	} else if (Array.isArray(sectionValue) && Number.isInteger(second) && typeof sectionValue[second]?.title === 'string') {
		place = sectionValue[second].title || place;
	} else if (!PLACE_LABELS[section] && sectionValue && typeof sectionValue === 'object' && !Array.isArray(sectionValue) && sectionValue.title) {
		place = sectionValue.title;
	}
	const rowAt = path.findIndex((key, index) => ROW_WORDS[key] && Number.isInteger(path[index + 1]));
	if (rowAt !== -1) place += ` · ${ROW_WORDS[path[rowAt]]} ${path[rowAt + 1] + 1}`;
	return place;
};
